<template>
  <div class="release-container">
    <div class="head-title">
        <p>发布数据集</p>
    </div>
    <div class="content-box">
      <el-form inline-message  :label-position="labelPosition" label-width="120px" :model="formLabelAlign" :rules="rules">
  <el-form-item label="数据集名称" prop="name">
      <el-input v-model="formLabelAlign.name"  class="eleInput"  type="text"
  placeholder="请输入数据集名称"
  maxlength="40"
  show-word-limit></el-input>
  </el-form-item>
  <el-form-item label="数据集封面">
    <el-upload
  class="avatar-uploader"
  action="https://jsonplaceholder.typicode.com/posts/"
  :show-file-list="false"
  :on-success="handleAvatarSuccess"
  :before-upload="beforeAvatarUpload">
  <img v-if="imageUrl" :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>
  <p class="P-message">封面尺寸:xxx*xxx,  支持jpg、png、jpeg的图片，大小不超过5MB</p>
  </el-form-item>
  <el-form-item label="数据集简介">
    <el-input v-model="formLabelAlign.type" class="eleInput"  type="text"
  placeholder="请输入数据集简介"
  maxlength="80"
  show-word-limit></el-input>
  </el-form-item>
  <el-form-item label="数据类型" >
      <el-select v-model="value1" multiple placeholder="请选择数据类型" >
    <el-option class="select"
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
  <el-form-item label="数据分类" >
      <el-select v-model="value2" multiple placeholder="请选择数据分类" >
    <el-option class="select"
      v-for="item in options2"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
  <el-form-item label="数据集上传">
<el-upload
  class="upload-demo"
  action="https://jsonplaceholder.typicode.com/posts/"
>
  <el-button size="small" type="primary" class="uploadbtn">选择文件</el-button>
  <div slot="tip" class="el-upload__tip">上传完整的数据集
  </div>
</el-upload>
  </el-form-item>
    <el-form-item label="测试数据集上传">
<el-upload
  class="upload-demo"
  action="https://jsonplaceholder.typicode.com/posts/"
>
  <el-button size="small" type="primary" class="uploadbtn">选择文件</el-button>
  <div slot="tip" class="el-upload__tip">上传可供使用的测试数据集
  </div>
</el-upload>
  </el-form-item>
  <el-form-item>
    <div class="select-box" v-for="(item,index) in list[0]" :key="index">
      <div class="select-box-head " >
        <p :class="[i===ind?'select-box-acitve Active-box-head':'']" v-for="(it,i) in item" :key="i" @click="handleClick(i)" >{{it.title}}</p>
        
      </div>
      <div class="select-box-content">
        <textarea v-model="list[0].contentList[ind].p"/>
      </div>
    </div>
  </el-form-item>
  <el-form-item v-for="(item,index) in radiolist" :key="index">
    <div class="radio-box" @click="handleRadio(item)">
      <div :class="[radioind===item.istrue?'radio radio-active':'radio']" ></div>
      <img :src="item.icon" alt="">
      <p class="type">{{item.type}}</p>
      <p >{{item.content}}</p>
    </div>
  </el-form-item>
  <el-form-item>
    <div class="btnlist">
      <button class="sucess">确认发布</button>
      <button class="save">存草稿</button>
      <button class="del">取消</button>
    </div>
  </el-form-item>
</el-form>
    </div>
  </div> 
</template>

<script>
import iconEye from "@/assets1/已发布数据集-已选_slices/icon_eye备份.png"
import iconDel from "@/assets1/已发布数据集-已选_slices/删除备份.png"
export default {
  data() {
      return {
        radiolist:[{
          istrue:0,icon:iconEye,type:'公开',content:'所有人都可以看见.'
        },{
          istrue:1,icon:iconDel,type:'私密',content:'只有数据发布者可见,发布后可修改为公开..'
        }],
   iconEye,
        labelPosition: 'right',
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        rules:{
          name: [
            { required: true, message: '请输入符合规范的数据集名称', trigger: 'blur' },
            { min: 3, max: 40, message: '长度在 3 到 40 个字符', trigger: 'blur' }
          ],
        },
        imageUrl: '',
        options: [{
          value: '工业制造',
          label: '工业制造'
        }, {
          value: '交通运输',
          label: '交通运输'
        }, {
          value: '金融服务',
          label: '金融服务'
        }, {
          value: '科技创新',
          label: '科技创新'
        }, {
          value: '绿色低碳',
          label: '绿色低碳'
        },{
          value: '气象服务',
          label: '气象服务'
        },{
          value: '商贸流通',
          label: '商贸流通'
        },{
          value: '文化旅游',
          label: '文化旅游'
        },{
          value: '现代农业',
          label: '现代农业'
        },{
          value: '医疗健康',
          label: '医疗健康'
        },{
          value: '应急管理',
          label: '应急管理'
        },{
          value: '城市治理',
          label: '城市治理'
        }],
        options2:[{
          value:'文本',
          label:'文本'
        }
        ,{
          value:'图片',
          label:'图片'
        },{
          value:'视频',
          label:'视频'
        },{
          value:'音频',
          label:'音频'
        },{
          value:'点云',
          label:'点云'
        }],
        value1:[],
        value2:[],
        list:[{contentList:[{title:'数据介绍',p:'数据介绍'},{title:'数据结构',p:'数据结构'},{title:'简介',p:'简介'}]}],
        ind:0,
        radioind:0

      };

    },
    methods:{
        handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      handleClick(i){
        this.ind=i
      },
      handleRadio(item){
    this.radioind=item.istrue
      }
    },
    mounted(){
    },
    watch:{
      value1(newValue){
        if(newValue.length!==0){
          document.querySelectorAll('.el-input--suffix input')[0].style.border='none'
          document.querySelectorAll('.el-input--suffix input')[0].style.backgroundColor='#F8F8F8'
          document.querySelectorAll('.el-input--suffix input')[0].style.boxShadow='none'
        }else{
          document.querySelectorAll('.el-input--suffix input')[0].style.border='1px solid #DCDFE6'
          document.querySelectorAll('.el-input--suffix input')[0].style.backgroundColor='#fff'
          document.querySelectorAll('.el-input--suffix input')[0].style.boxShadow='0px 0px 5px 1px #E0E0E0'
        }
      },
        value2(newValue){
        if(newValue.length!==0){
          document.querySelectorAll('.el-input--suffix input')[1].style.border='none'
          document.querySelectorAll('.el-input--suffix input')[1].style.backgroundColor='#F8F8F8'
          document.querySelectorAll('.el-input--suffix input')[1].style.boxShadow='none'
        }else{
          document.querySelectorAll('.el-input--suffix input')[1].style.border='1px solid #DCDFE6'
          document.querySelectorAll('.el-input--suffix input')[1].style.backgroundColor='#fff'
          document.querySelectorAll('.el-input--suffix input')[1].style.boxShadow='0px 0px 5px 1px #E0E0E0'
        }
      }
    }
      
}
</script>

<style scoped>
.sucess{
  color: white;
  background-color: #0D53FF;
}.save{
  color: #666;
  background-color: #F7F7F7;
}
.del{
  color: #666;
  background-color: #fff;
}
.btnlist{
  display: flex;
}
.btnlist button{
  width: 80px;
  height: 32px;
  margin-right: 20px;

  font-size: 14px;
  font-family:Regular ;
  border: 1px solid #E9E9E9;
  border-radius: 4px;
}
.radio.radio-active::before{
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  background-color: #0D53FF;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.radio.radio-active{
    border: 1px solid #0D53FF;
}
.radio{
  position: relative;
  width: 14px;height: 14px;border-radius: 50%;
  border: 1px solid #000;
  margin-right: 20px;
  cursor: pointer;
}
.radio-box{
  display: flex;
  align-items: center;
}
.radio-box .type{
  font-size: 14px;
  line-height: 20px;
  font-family:Regular ;
  color: #000;
  margin: 0 8px;
}
.radio-box p{
  font-size: 12px;
  line-height: 20px;
  font-family:Regular ;
  color:#999999 ;
}
.radio-box img{
  width: 20px;
  height: 20px;
  object-fit: cover;
}
.select-box-content textarea{
  padding:10px 20px;
  border: none;outline: none;
  font-family: Regular;
  width: 100%;
  height: 100%;
  resize: none;
}
.select-box-acitve.Active-box-head{
 z-index: 1;
 height: 31px;
}
.select-box-content{
  position: absolute;
  top: 30px;
  width: 100%;
  height: 100px;
  border: 1px solid rgba(153, 153, 153, .3);
}
.select-box-head{
position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
background-color: #fff;
}
.select-box-head p{
    
  width: 90px;
  height: 30px;
  line-height: 30px;
  background-color: #eee;
  border-radius: 4px 4px 0 0 ;
  text-align: center;
  color: #999;
  margin-right: 2px;
  border: 1px  solid rgba(153, 153, 153, .3);
  border-bottom: none;
  cursor: pointer;
   
}
.select-box-head .select-box-acitve{
  background-color: #fff;
  color: #0D53FF;
  font-size: 14px;
 
}
.select-box{
position: relative;
  width: 570px;
  height: 135px;
  font-family:Regular ;
}
.el-upload__tip{
  line-height: 30px;
  font-size: 12px;
  font-family:Regular ;
  color: #999999;
  margin-left: 11px;
}
.uploadbtn{

  height: 36px;
  
  border: 1px solid rgba(13,83,255,0.6);
  border-radius: 4px;
  background-color:rgba(13,83,255,0.1);
  font-size: 14px;
  color: #0D53FF;
}
.upload-demo{
display: flex;
}
/* .active{
  border: none;
  box-shadow: none;
  background-color: #F8F8F8;
} */
::v-deep .el-input--suffix input{

}
::v-deep .el-select{
 
 width: 576px;
}

::v-deep .el-select__tags-text{
  line-height: 17px;
  
}
::v-deep .el-tag{
padding: 8px;
color: black;
font-family: Regular;
height: auto;
  border: 1px solid #0D53FF;
  background-color: #fff;
  font-size: 14px;
}
/* .select{
 background-color: #F8F8F8;
  border: none;
} */
.P-message{
  font-size: 12px;
  font-family: Regular;
  color: #999999;
  height: 17px;
  line-height: 17px;
}

 /* .el-form-item {
  display: flex;
  align-items: center;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 10px;
} */
/* ::v-deep  .el-form-item__error{
left:calc();
top: 0;
 } */
::v-deep  .avatar-uploader .el-upload {
    /* border: 1px solid #E0E0E0; */
    box-shadow: 0px 0px 5px 2px #E0E0E0;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    height: 60px;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 60px;
    height: 60px;
    display: block;
  }
.eleInput{
  width: 570px;
    height: 36px;
    
   
}
::v-deep .el-input__inner{
 box-shadow: 0px 0px 5px 1px #E0E0E0;
}
.form-group{
    display: flex;
    justify-content: flex-end;
}
.head-title{
    font-family: Medium;
    font-size: 24px;
    margin-bottom: 26px;
}
.release-container{
    padding-left: 24px;
    padding-top: 24px;
}
</style>